import React, { FC, useContext } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { bankCardMobx } from '@mobxStore'
import SelectBankCardModal from '@pages/mall/checkout/modal/SelectBankCardModal'

interface IProps {
  payRechargeFlag?: boolean;
  bankCards?: IMutBankCardInfo[];
  selected: boolean;
  amount: number;
  card: TBankCardInfo;
  onChange: (data?: any) => void;
}

const BankCardSimpleItem: FC<IProps> = ({ payRechargeFlag, bankCards, selected, amount, onChange, card }) => {
  bankCards = bankCards || bankCardMobx?.memberBankCards
  const handleChange = () => {
    if (selected && card?.tokenType === 'multi' && bankCards?.length > 0) {
      modalLayer(SelectBankCardModal, { payRechargeFlag, bankCards, selectedCard: card }, 'selectBankCardModal').then((data: any) => {
        onChange(data)
      }).catch(() => {
        onChange()
      })
    } else {
      onChange()
    }
  }

  return (
    <div
      className={classNames(
        'mall-external-pay-method-item',
        'bank-card-online',
        { selected }
      )}
      onClick={handleChange}
    >
      <div className='card-left'>
        <i className='iconfont icon-xinyongka'> </i>
      </div>
      <div className='card-content'>
        <div className='title-top'>
          <div className='name'>{card && card.tokenType === 'multi' && card.creditCardNumber ? format.maskCardNumber(card.creditCardNumber) : i18n.t('pay.bankCard')}</div>
          {bankCards?.length > 0 ? (<div className='triangle-tip'></div>) : ''}
        </div>
        <div className='amount'>
          {selected && format.toPrice(amount)}
        </div>
      </div>
      <div className='amount-select'>
        <i className={classNames('iconfont', selected ? 'icon-checked' : 'no-select')} />
      </div>
    </div>
  )
}

export default observer(BankCardSimpleItem)
